import gql from 'graphql-tag';
import { parseToMutationRequest } from '../../utils/utils';

export default payload => {
  const type  = parseToMutationRequest(payload, ['type']);
  return gql`
  query {
    getDashBoardByType(input: ${type}) {
      dashboards {
        name
        data {
          mon
          value
        }
      }
    }
  }
`;
};
